module.exports = __webpack_public_path__ + "static/media/menuEarlyBird.3333349e.png";